// Func = limiting Scope for this file
var lastScrollTop = 0;

//vanilla variables for resizing 
var w = window,d = document,e = d.documentElement,g = d.getElementsByTagName('body')[0],windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

resizeWindow();

(function () {


	// Main Nav Dropdown
	const navItems = document.querySelectorAll('#primary-nav li');
	navItems.forEach(function (item) {
		item.addEventListener('mouseover', function () {
			item.classList.add('hover');
			let submenu = item.querySelector('ul.submenu');
			if (submenu) {
				submenu.classList.add('open');
			}
		});

		item.addEventListener('mouseout', function () {
			item.classList.remove('hover');
			let submenu = item.querySelector('ul.submenu');
			if (submenu) {
				submenu.classList.remove('open');
			}
		});
	});

	//Nav parent active primary menu desktop
	let item = document.querySelector('.privary-navigation__submenu .active');
	if (item != undefined) {
		let itemSubmenu = item.parentElement.parentElement.parentElement.firstElementChild;
		itemSubmenu.classList.add("active");
	}
	
	// burger menu cta open
	document.querySelector(".burger-open-js").addEventListener("click", (e)=>{
		e.preventDefault();
		document.querySelector(".burger-menu").classList.add("open")
		document.querySelector("body").classList.add("no-scroll")
	})

	// burger menu cta remove
	document.querySelector(".burger-close-js").addEventListener("click", (e)=>{
		e.preventDefault();
		document.querySelector(".burger-menu").classList.remove("open")
		document.querySelector("body").classList.remove("no-scroll")
	})
	
	//Booking CTA open
	document.querySelectorAll(".booking-js").forEach( btn => {
		btn.addEventListener("click", (e)=> {
			e.preventDefault();
			document.querySelector("#booking-engine").classList.add("open");
			document.querySelector("body").classList.add("no-scroll");
		})
	});

	//Booking CTA close
	document.querySelector(".close-booking-js").addEventListener("click", (e) =>{
		e.preventDefault();
		document.querySelector("#booking-engine").classList.remove("open");
		document.querySelector("body").classList.remove("no-scroll");
	})


	window.onload = function () {
		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
	};

	//remove function click
	document.querySelectorAll('.no-click-js').forEach((item) => {
		item.addEventListener("click", (e) => {
			e.preventDefault()
		})
	})

	
	//email signup animation 
	if (document.getElementById('email-signup')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		})
		if (document.getElementById('email-signup_LNAME') != null) {
			
			document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
				this.parentElement.classList.add('moved');
			})
		}
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		})

	}

	//selec signup
	document.addEventListener('DOMContentLoaded', function() {
		
		const select = document.getElementById('email-signup_state');
		const optionToMove = select.querySelector('option[value="Outside the U.S"]');
	
		
		if (optionToMove) {
			select.appendChild(optionToMove); 
		}
	});
	
	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		let allffields = document.getElementsByClassName('form-module__field');

		for (let j = 0; j < allffields.length; j++) {

			if (allffields[j].getElementsByTagName('input').length > 0) {
				if (allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					})
				}
			}
			if (allffields[j].getElementsByTagName('select').length > 0) {
				allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				})
			}
			if (allffields[j].getElementsByTagName('textarea').length > 0) {
				allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				})
			}
		}
	}
		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function(inst) {
		$.datepicker._updateDatepicker_original(inst);
		var afterShow = this._get(inst, 'afterShow');
		if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null)); // trigger custom callback
		}


}());


function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if(document.querySelector("#home") == null && window.innerWidth <= 767 ){
			document.getElementById('header').classList.add('up');
		}

	}

	if (document.getElementById("top-content") == null) {
		document.querySelector("header").classList.add("no-top")
	}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}



function resizeWindow() {
	//calculate a new window size
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

	//header image to be window height on homepage
	if (document.getElementsByClassName('img-slide').length > 0 || document.querySelector("#home.home-page") != null) {
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for (let i = 0; i < headerImagesLength; i++) {
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}


}

//class for scroll
let classtoscroll = document.querySelectorAll(".scroll-js");
if (classtoscroll) {
	classtoscroll.forEach(item =>{
		item.addEventListener("click", (e)=>{
			e.preventDefault();
			let sectiongoto = e.target.hash.split("#")[1];
			animateTo(sectiongoto)
		});
	});
}

//animation of scroll vanilla JS
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from = window.pageYOffset
	var to = gotoTarget
	var duration = 1800;
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start

		if (from <= to) {
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {

			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft
	}
}


/* Subnav on mobile */
let submenuHold = document.querySelectorAll('.sub-menu__hold');
let allsublinks = document.querySelectorAll('.sub-menu a');
if(allsublinks.length > 1){
	allsublinks.forEach(ele=>{
		ele.addEventListener('click', function(ev){
			if(ele.classList.contains('active')){
				ev.preventDefault();
			}
		});
	});
	let toggleBtn = document.querySelector('.sub-menu__toggle');
	if(toggleBtn){
		//toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
		toggleBtn.addEventListener('click', function(){
			toggleBtn.parentElement.classList.toggle('open');
		});
	}
}else if(submenuHold.length > 0){
	submenuHold[0].classList.add('hidden');
}

//funcionality for generad tab

function tagsection(tabSelector, tabcontentSelector, selectnavSelector) {
	const allTabs = document.querySelectorAll(tabSelector);
	const selectTab = document.querySelector(selectnavSelector);
	const allSections = document.querySelectorAll(tabcontentSelector);
	let selectItem = null;

	const TabClick = (tab) => {
			if (selectItem) {
					selectItem.classList.remove('active');
			}
			tab.classList.add('active');
			selectItem = tab;

			const tabDataItem = tab.getAttribute('data-item');
			allSections.forEach(content => {
					content.classList.remove('active');
					const contentDataItem = content.getAttribute('data-item');
					if (tabDataItem === 'all' || tabDataItem === contentDataItem) {
							content.classList.add('active');
					}
			});
	};

	let isFirstTabActivated = false;

	allTabs.forEach((tab, i) => {
			tab.addEventListener('click', function (e) {
					e.preventDefault();
					TabClick(tab);
			});
			if (!tab.getAttribute('data-item')) {
					tab.setAttribute('data-item', `item${i}`);
			}
			if (!isFirstTabActivated) {
					allTabs[0].click();
					allSections[0].classList.add('active')
					isFirstTabActivated = true;
			}
	});

	allSections.forEach((section, i) => {
			if (!section.getAttribute('data-item')) {
					section.setAttribute('data-item', `item${i}`);
			}
	});
	
	if(selectTab){
		selectTab.addEventListener('change', (e) => {
				const selectedValue = selectTab.value;
				allSections.forEach(content => {
						content.classList.remove('active');
						const contentDataItem = content.getAttribute('data-item');
						if (selectedValue === 'all' || selectedValue === contentDataItem) {
								content.classList.add('active');
						}
				});
		});
	}
}
